import { fromId } from './time-series-data/util/dataStreamId';
import { completePropertyStream } from './asset-modules/util/completePropertyStream';
import { completeAlarmStream } from './alarms/iotevents/util/completeAlarmStream';
/**
 * Get completed data streams by merging together the data streams with the asset models and alarms.
 */
export const completeDataStreams = ({ modeledDataStreams, dataStreams, assetModels, alarms, }) => {
    return dataStreams.map((dataStream) => {
        var _a;
        const propertyInfo = fromId(dataStream.id);
        if ('propertyAlias' in propertyInfo) {
            const latestValue = (_a = dataStream.data.at(-1)) === null || _a === void 0 ? void 0 : _a.y;
            const dataType = typeof latestValue === 'boolean'
                ? 'BOOLEAN'
                : typeof latestValue === 'string'
                    ? 'STRING'
                    : 'NUMBER';
            return { ...dataStream, name: propertyInfo.propertyAlias, dataType };
        }
        const { assetId, propertyId } = propertyInfo;
        const assetModel = assetModels[assetId];
        const propertyStream = completePropertyStream({
            modeledDataStreams,
            assetModel,
            dataStream,
            assetId,
            propertyId,
            alarms,
        });
        const alarmPropertyStream = completeAlarmStream({
            assetModel,
            propertyId,
            dataStream,
        });
        if (propertyStream) {
            return propertyStream;
        }
        if (alarmPropertyStream) {
            return alarmPropertyStream;
        }
        return dataStream;
    });
};
